import * as React from 'react';

import PagesForMac32 from './PagesForMac32';

export const pagesForMac32 = () => <PagesForMac32 />;

export default {
    title: 'Icon/Logo/PagesForMac32',
    component: PagesForMac32,
    parameters: {
        notes: "`import PagesForMac32 from 'box-ui-elements/es/icon/logo/PagesForMac32';`",
    },
};
